import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

require('classlist-polyfill');
require('react-datepicker/dist/react-datepicker.css');


const DocketPacerSearchBar = (props) => {
  const {
    showLoadingBar,
    showPastEntries,
    pastEntriesHide,
    changePacerFilter,
    changePacerDate,
    handlePacerDateChangeRaw,
    pacerSearch,
    buyDocketSheet,
    clear,
  } = props;

  const clsName = showLoadingBar ? 'dim' : '';

  return (
    <div id="pacer-filter" className={`inside-block ${clsName}`}>

      {showPastEntries && (
        <div className="hide-link" onClick={pastEntriesHide}>Hide ×</div>
      )}

      <div className="tip">
        Leave blank for entire docket or specify document or date range to import partial docket sheet
      </div>

      <div id="pacer-docket-form">
        <input className="form-text"
               value={pacerSearch.doc_from || ''}
               onChange={e => changePacerFilter(e, 'doc_from')}
               type="text"
               placeholder="Doc#" />

        <span>&nbsp;to&nbsp;</span>

        <input className="form-text"
               value={pacerSearch.doc_to || ''}
               onChange={e => changePacerFilter(e, 'doc_to')}
               type="text"
               placeholder="Doc#" />

        <span>&nbsp;OR&nbsp;</span>

        <div className="date-selector">
          <DatePicker
            selected={pacerSearch.startDate}
            onChange={changePacerDate.bind(null, 'startDate')}
            dateFormat="MM/DD/YYYY"
            isClearable
            placeholderText="date"
            onChangeRaw={handlePacerDateChangeRaw.bind(null, 'startDate')} />
        </div>

        <span>&nbsp;to&nbsp;</span>

        <div className="date-selector">
          <DatePicker
            selected={pacerSearch.endDate}
            onChange={changePacerDate.bind(null, 'endDate')}
            dateFormat="MM/DD/YYYY"
            isClearable
            placeholderText="date"
            onChangeRaw={handlePacerDateChangeRaw.bind(null, 'endDate')} />
        </div>

        <button type="submit" className="form-submit green" onClick={buyDocketSheet}>
          Buy Docket Sheet
        </button>

        <a className="form-reset" onClick={clear}>
          Clear
        </a>
      </div>
    </div>
  );
};

DocketPacerSearchBar.propTypes = {
  showLoadingBar: PropTypes.any.isRequired,
  showPastEntries: PropTypes.any.isRequired,
  pastEntriesHide: PropTypes.any.isRequired,
  changePacerFilter: PropTypes.any.isRequired,
  changePacerDate: PropTypes.any.isRequired,
  handlePacerDateChangeRaw: PropTypes.any.isRequired,
  pacerSearch: PropTypes.any.isRequired,
  buyDocketSheet: PropTypes.any.isRequired,
  clear: PropTypes.any.isRequired,
};

export default DocketPacerSearchBar;



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/DocketPacerSearchBar.jsx
 **/